import {
  BaseAPI,
} from '@/internal';

export default class FormResponseFileAPI extends BaseAPI {

  zip(id, name, params) {
    return this.get({
      url: `form-responses/${id}/files/zip`,
      headers: [],
      queryParams: params,
    }).then(res => res.blob())
      .then((response) => {
        const file = new Blob(
          [response],
          {type: 'application/zip'},
        );
        const link = document.createElement('a');
        link.href =  URL.createObjectURL(file);
        link.download = `${name}.zip`;
        document.body.append(link);
        link.click();
        link.remove();
      });
  }
};